export default __webpack_public_path__ + "static/media/received_parcels.a592bd5e.svg";